// removed by extract-text-webpack-plugin
module.exports = {"popoverZIndex":"19","popoverOZIndex":"21"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/variables.scss
 ** module id = 996
 ** module chunks = 0
 **/